import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import PricingPage from './components/PricingPage';
import PaymentSuccess from './components/PaymentSuccess';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import AdminPage from './components/AdminPage';
import SimracingPage from './components/SimracingPage';
import PitEngineer from './components/PitEngineer';
import TelemetryPage from './components/TelemetryPage';
import ReplayStudio from './components/ReplayStudio';
import LiveTelemetryPanel from './components/LiveTelemetryPanel';
import InstallAppButton from './components/InstallAppButton';
import GlobalTopbar from './components/GlobalTopbar';
import { ThemeProvider } from './theme/ThemeProvider';
import './i18n'; // initialises react-i18next with ES default
import './config/api'; // installs axios defaults + Authorization interceptor
import '@/App.css';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - detect BEFORE ProtectedRoute runs
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <GlobalTopbar />
      <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route 
        path="/app" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/simracing" 
        element={<SimracingPage />} 
      />
      <Route 
        path="/pit-engineer" 
        element={
          <ProtectedRoute>
            <PitEngineer />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/telemetry" 
        element={
          <ProtectedRoute>
            <TelemetryPage />
          </ProtectedRoute>
        } 
      />
      <Route
        path="/replay/:eventId/:tandaKey"
        element={
          <ProtectedRoute>
            <ReplayStudio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/replay/session/:sessionId"
        element={
          <ProtectedRoute>
            <ReplayStudio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/live"
        element={
          <ProtectedRoute>
            <div
              className="min-h-screen p-4 md:p-6"
              style={{ backgroundColor: 'var(--dp-bg)' }}
            >
              <LiveTelemetryPanel />
            </div>
          </ProtectedRoute>
        }
      />
      </Routes>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
          <InstallAppButton />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
